export default __webpack_public_path__ + "static/media/tick-white.803d2a62.svg";